package com.fireavert.react.shared

import mui.material.*
import mui.system.sx
import react.FC
import react.Props
import react.dom.events.ChangeEvent
import react.useState
import web.cssom.pct
import web.cssom.px
import web.dom.ElementId
import web.html.HTMLInputElement

external interface SelectorDropDownProps : Props {
    var labelText: String
    var optionMap: Map<String, Int?>
    var onChange: (Int?) -> Unit
    var mobileVersion: Boolean
    var disabled: Boolean
    var defaultSelection: String?
}

val SelectorDropDown = FC<SelectorDropDownProps> { props ->
    // Transform the map to a list of options for Autocomplete
    val options = props.optionMap.keys.toTypedArray()

    // Use the provided defaultSelection or fall back to the first key
    val initialValue = props.defaultSelection ?: props.optionMap.keys.firstOrNull() ?: ""

    val (selectedValue, setSelectedValue) = useState(initialValue)

    FormControl {
        variant = FormControlVariant.outlined

        InputLabel {
            id = ElementId("dropdown-label")
            +props.labelText
        }

        Select {

            labelId = "dropdown-label"
            fullWidth = true
            value = selectedValue
            onChange = { event: ChangeEvent<HTMLInputElement>, name ->
                val selectedKey = event.target.value as String
                val selectedValue = props.optionMap[selectedKey]
                // Update the state variable
                setSelectedValue(selectedKey)
                // Call the props.onChange callback
                props.onChange(selectedValue)
            }

            // Render all options
            props.optionMap.forEach { (key, _) ->
                MenuItem {
                    value = key // Use the text key as the value
                    +key
                }
            }

            disabled = props.disabled
            sx {
                if (props.mobileVersion) {
                    width = 100.pct
                    maxWidth = 150.px
                } else {
                    width = 230.px
                }
            }
        }
    }
}